/**
 * TODO:
 * - fetch saved portfolio
 */

import {
	all,
	call,
	fork,
	put,
	takeEvery,
	takeLatest,
} from 'redux-saga/effects';

// Login Redux States
import { api } from 'api';
import {
	COPY_PORTFOLIO,
	GET_PORTFOLIO,
	GET_PORTFOLIOS,
	GET_PORTFOLIO_AND_REDIRECT,
	PORTFOLIO_API_ERROR_CLEAR,
	SAVE_PORTFOLIO,
} from './actionTypes';
import {
	ICopyPortfolio,
	getPortfolioSuccess,
	getPortfolios,
	getPortfoliosSuccess,
	insertPortfolioToStore,
	portfolioApiError,
	portfolioApiErrorClear,
} from './actions';

// AUTH related methods
import { AxiosResponse } from 'axios';
import { Portfolio, SaveRes, SaveStatus } from 'api';
import { apiLoading, apiResError, apiReset, apiResSuccess } from '../actions';

 export interface IPortfolioPayload {
	payload:
		| number
		| Portfolio
		| ICopyPortfolio
		| IPayloadWithCB
		| IPortfolioPayloadWithCB;
	type: string;
}

export interface IPayloadWithCB {
	id: number;
	redirect: () => void;
}
export interface IPortfolioPayloadWithCB {
	portfolio: Portfolio;
	redirect: () => void;
}

function* fetchPortfolios() {
	try {
		const response: AxiosResponse<Portfolio[]> =
			yield api.portfolio.apiPortfolioDataGet();

		yield put(getPortfoliosSuccess(response.data));
	} catch (error: any) {
		yield put(portfolioApiError(error.message));
	}
}

function* fetchPortfolio({ payload }: IPortfolioPayload) {
	try {
		const response: AxiosResponse<Portfolio> =
			yield api.portfolio.apiPortfolioDataGetIdGet(payload as number);
		yield put(getPortfolioSuccess(response.data));
	} catch (error: any) {
		yield put(portfolioApiError(error.message));
	}
}

function* fetchPortfolioAndRedirect({ payload }: IPortfolioPayload) {
	try {
		const { id, redirect } = payload as IPayloadWithCB;
		const response: AxiosResponse<Portfolio> =
			yield api.portfolio.apiPortfolioDataGetIdGet(id);
		yield put(getPortfolioSuccess(response.data));
		yield call(redirect);
	} catch (error: any) {
		yield put(portfolioApiError(error.message));
	}
}

function* fetchPortfolioAndInsert(id: number) {
	try {
		const response: AxiosResponse<Portfolio> =
			yield api.portfolio.apiPortfolioDataGetIdGet(id);

		yield put(insertPortfolioToStore(response.data));
	} catch (error: any) {
		yield put(portfolioApiError(error.message));
	}
}

function* savePortfolio({ payload }: IPortfolioPayload) {
	yield put(apiLoading());

	try {
		let response: AxiosResponse<SaveRes>;
		const { portfolio, redirect } = payload as IPortfolioPayloadWithCB;
		console.log('SAGA save portfolio', portfolio);
		if (portfolio.id && portfolio.id !== 0) {
			response = yield api.portfolio.apiPortfolioDataIdPut(
				portfolio.id,
				portfolio
			);
		} else {
			response = yield api.portfolio.apiPortfolioDataPost(portfolio);
		}

		if (response.data.status === SaveStatus.Success) {			
			yield call(fetchPortfolios);
			yield put(apiReset());
			yield call(redirect);
			yield put(
				apiResSuccess(response.data.message || 'Save successfull')
			);
		} else {
			yield put(apiResError(response.data.message as string));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

function* copyPortfolio({ payload }: IPortfolioPayload) {
	yield put(apiLoading());
	try {
		const { id, name } = payload as ICopyPortfolio;
		const response: AxiosResponse<SaveRes> =
			yield api.portfolio.apiPortfolioDataCopyIdPost(id, name);

		if (response.data.status === SaveStatus.Success) {
			const createdId = response.data.createdId || 0;
			yield put(
				apiResSuccess(response.data.message || 'Copy successfull')
			);
			yield call(fetchPortfolioAndInsert, createdId);
		} else {
			yield put(apiResError(response.data.message || 'Copy failed'));
			yield put(portfolioApiError(response.data.message as string));
		}
	} catch (error: any) {
		yield put(apiResError(error.message));
		//yield put(portfolioApiError(error.message));
	}
}

function* clearApiError() {
	try {
		yield call(portfolioApiErrorClear);
	} catch (error) {
		console.log(error);
	}
}

export function* watchFetchPortfolios() {
	yield takeLatest(GET_PORTFOLIOS, fetchPortfolios);
}

export function* watchFetchPortfolio() {
	yield takeLatest(GET_PORTFOLIO, fetchPortfolio);
}
export function* watchFetchPortfolioAndRedirect() {
	yield takeEvery(GET_PORTFOLIO_AND_REDIRECT, fetchPortfolioAndRedirect);
}

export function* watchSavePortfolio() {
	yield takeEvery(SAVE_PORTFOLIO, savePortfolio);
}

export function* watchCopyPortfolio() {
	yield takeEvery(COPY_PORTFOLIO, copyPortfolio);
}

export function* watchClearApiError() {
	yield takeEvery(PORTFOLIO_API_ERROR_CLEAR, clearApiError);
}

function* portfolioSaga() {
	yield all([
		fork(watchFetchPortfolios),
		fork(watchFetchPortfolio),
		fork(watchFetchPortfolioAndRedirect),
		fork(watchSavePortfolio),
		fork(watchCopyPortfolio),
		fork(watchClearApiError),
	]);
}

export default portfolioSaga;
